<app-card [customClasses]="'text-center bg-dashboard-card border-0 py-1 px-1 br-9 h-100 profile'">
  <!-- Avatar -->
  <div class="user-section mb-3">
    <img [src]="avatar" alt="User Avatar" class="rounded-circle cover mt-3" width="100" height="100" />

    <!-- Name + Points -->
    <div class="d-flex align-items-center justify-content-center mt-3 mb-2 gap-2 flex-wrap user-info">
      <h5 class="fs-26 fg-400 text-color">{{ name }}</h5>
      <span class="points-badge fs-12 fg-400 text-icon bg-icon rounded-pill text-white mb-2 p-1 br-40 b-2-light-purple">
        {{ points }}{{ pointsSuffix }}
      </span>
    </div>

    <!-- Rôle et parcours : repris du bandeau d'identité, qui répétait le nom et
         l'avatar ci-dessus pour une seule ligne d'information utile. -->
    <div *ngIf="kind" class="profile-identity d-flex align-items-center justify-content-center gap-2 flex-wrap mb-2">
      <span class="profile-identity__role">
        <i [class]="kindIcon"></i>
        {{ kindLabelKey | translate }}
      </span>
      <span *ngIf="showLearningPath" class="profile-identity__path">
        <i class="fa-solid fa-route"></i>
        {{ learningPath }}
      </span>
    </div>

    <!-- Niveau d'XP : le classement Top 5 ne dit pas où se situe l'élève qui
         n'y figure pas ; le niveau et la barre de palier le lui disent ici. -->
    <div *ngIf="showXp" class="profile-xp mx-auto mb-3">
      <div class="profile-xp__head">
        <span class="profile-xp__level">
          <i class="fa-solid fa-bolt"></i>
          {{ 'DASHBOARD.XP.LEVEL' | translate:{ level: xp!.level } }}
        </span>
        <span class="profile-xp__total">
          {{ 'DASHBOARD.XP.TOTAL' | translate:{ xp: xp!.totalXp } }}
        </span>
      </div>

      <div class="profile-xp__bar" role="progressbar"
           [attr.aria-valuenow]="xpProgress" aria-valuemin="0" aria-valuemax="100">
        <span [style.width.%]="xpProgress"></span>
      </div>

      <div class="profile-xp__foot">
        <span *ngIf="xp!.xpToNextLevel > 0">
          {{ 'DASHBOARD.XP.TO_NEXT' | translate:{ xp: xp!.xpToNextLevel, level: xp!.level + 1 } }}
        </span>
        <span *ngIf="xp!.xpToNextLevel <= 0">{{ 'DASHBOARD.XP.MAX_LEVEL' | translate }}</span>
        <span *ngIf="xp!.rank > 0" class="profile-xp__rank">
          <i class="fa-solid fa-ranking-star"></i>
          {{ 'DASHBOARD.XP.RANK' | translate:{ rank: xp!.rank, total: xp!.totalStudents } }}
        </span>
      </div>
    </div>

    <!-- Optional Button -->
    <div *ngIf="showButton" class="flex flex-column mt-4 mb-4 mx-5">
      <app-button [label]="buttonText" [type]="'button'" [customClasses]="'py-3 fs-19 fg-700 btn-create-test'"
        [link]="buttonLink"></app-button>
    </div>
  </div>

  <!-- Stats -->
  <div class="stats-container d-flex flex-wrap justify-content-center gap-4 px-5 mb-3 mt-1">
    <div class="stat-card" *ngFor="let st of statistics">
      <div class="card stat-box d-flex justify-content-center align-items-center border-0 br-9">
        <div class="card-body">
          <div class="d-flex align-items-center">
            <div class="flex-grow-1">
              <i class="{{ st.icon }} fs-20 p-2 mb-1 br-9 bg-stat-icon text-stat-icon"></i>
              <div class="stat-title fs-15 fg-400 text-color">{{ st.title | translate }}</div>
              <div class="point fs-19 fg-400 text-color mb-1">{{ st.points }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Optional Pie Chart -->
  <ng-content select="[chart]"></ng-content>
</app-card>